import {
    FETCH_SAMPLES_LIST,
    FETCH_LOCATIONS_LIST,
    SAVE_SAMPLE,
    DELETE_SAMPLE,
    MODIFY_SAMPLE_DATA,
    FETCH_SAMPLE_DATA,
    FETCH_DASHBORD_DATA,
    DELETE_MULTIPLE_SAMPLES,
    FETCH_LOCATION_TREND_DATA
} from "../actions/types"

const INITIAL_STATE = {
    downloadSampleData: [],
    sampleList: [],
    locationList: [],
    allPagination: {
        currentPage: 1,
        totalPages: 0
    },
    dashboardData: {},
    sampleParams: {},
    locationTrendData: []
}
let calculateTotalPages = (totalCount, pageSize) => {
    return (totalCount && pageSize) ? (Math.floor(totalCount / pageSize) + (totalCount % pageSize ? 1 : 0)) : 1
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_SAMPLES_LIST:
            return {
                ...state,
                sampleList: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload,
                allPagination: {
                    currentPage: action.payload.current_page,
                    totalPages: calculateTotalPages(action.payload.total_count, action.payload.page_size)
                },
                sampleParams: action.param
            }
        case FETCH_SAMPLE_DATA:
            return {
                ...state,
                downloadSampleData: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload
            }
        case FETCH_DASHBORD_DATA:
            return {
                ...state,
                dashboardData: action.payload
            }
        case FETCH_LOCATIONS_LIST:
            return { ...state, locationList: action.payload.locationData }
        case SAVE_SAMPLE:
            return { ...state, sampleList: [action.payload, ...state.sampleList], downloadSampleData: [action.payload, ...state.downloadSampleData] };
        case DELETE_SAMPLE:
            return { ...state, sampleList: [...state.sampleList.filter(val => val.id !== action.payload.data)], downloadSampleData: [...state.downloadSampleData.filter(val => val.id !== action.payload.data)] };
        case DELETE_MULTIPLE_SAMPLES:
            return { ...state, sampleList: [...state.sampleList.filter(val => !action.payload.data.includes(val.id))], downloadSampleData: [...state.downloadSampleData.filter(val => !action.payload.data.includes(val.id))] };
        case FETCH_LOCATION_TREND_DATA:
            return {
                ...state,
                locationTrendData: action.payload
            }
        case MODIFY_SAMPLE_DATA:
            if (action.payload) {
                const samples = state.sampleList.filter(val => val.sample_id !== action.payload.sample_id)
                const allSamples = state.downloadSampleData.filter(val => val.sample_id !== action.payload.sample_id)
                return { ...state, sampleList: [action.payload, ...samples], downloadSampleData: [action.payload, ...allSamples] }
            }
            else
                return state
        default:
            return state;
    }
}